import { formatCurrency } from "@/pages/deals/components/commercials/DealCommercialsV2/ContractTermsV2/consts";

export interface VersionDelta {
  label: string;
  isIncrease: boolean;
}

// The signed TCV movement against the previous version, or null where there is
// nothing to state: the initial terms have no predecessor, either side may have
// no figure to subtract, and a version that moved TCV by nothing is not a
// change worth colouring. Cent precision, matching the editor's own footer —
// rounding to whole units would hide a real difference under 50c.
export const versionTcvDelta = (
  change: number | null,
  currency: string | null
): VersionDelta | null => {
  if (change == null) return null;
  // On the magnitude: Math.round(-0.005 * 100) is -0, which === 0, so a negative
  // half-cent was suppressed while its positive twin rendered as "+$0.01" —
  // the label formats Math.abs(change), so the two have to agree on the bound.
  if (Math.round(Math.abs(change) * 100) === 0) return null;
  const isIncrease = change > 0;
  return {
    label: `${isIncrease ? "+" : "-"}${formatCurrency(Math.abs(change), currency)}`,
    isIncrease
  };
};
